import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TextboxComponent } from '../../../form_components/text-box/text.component';

@Component({
  selector: 'app-menu-search',
  templateUrl: './menu_search.component.html',
  styleUrls: ['./menu_search.component.scss'],  
  imports: [FormsModule,CommonModule, TextboxComponent],
})
export class GlobalSearchComponent {

  searchText = '';

  menus = [];

  filteredMenus = [];

  selectedIndex = 0;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<GlobalSearchComponent>
  ) {

     const d: any = localStorage.getItem('currentUser');
    const storedData: any = JSON.parse(d);
    if (storedData || storedData.user.menu_list) {
      this.menus = storedData.user.menu_list;
    }
  }

  onSearch() {
    this.filteredMenus = this.menus.filter((menu : any) =>
      menu.name.toLowerCase().includes(this.searchText.toLowerCase())
    );

    this.selectedIndex = 0;
  }

  onKeyDown(event: KeyboardEvent) {

    if (event.key === 'ArrowDown') {
      this.selectedIndex =
        (this.selectedIndex + 1) % this.filteredMenus.length;
    }

    if (event.key === 'ArrowUp') {
      this.selectedIndex =
        (this.selectedIndex - 1 + this.filteredMenus.length) %
        this.filteredMenus.length;
    }

    if (event.key === 'Enter') {
      const selectedMenu : any = this.filteredMenus[this.selectedIndex];

      if (selectedMenu) {
        this.router.navigate([selectedMenu.url]);
        this.dialogRef.close();
      }
    }
  }

  Click(menu:any) {
        this.router.navigate([menu.url]);
        this.dialogRef.close();
      }
}